import { render } from "./QaDetails.vue?vue&type=template&id=45a67c68&ts=true"
import script from "./QaDetails.vue?vue&type=script&lang=ts"
export * from "./QaDetails.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__